var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.13563L9.27406 13.49C9.37392 13.5477 9.47864 13.5893 9.58523 13.6157V24.0003L0.661427 18.7192C0.251457 18.4766 0 18.0356 0 17.5592V8.13563ZM21.5667 7.99311V17.559C21.5667 18.0354 21.3153 18.4764 20.9053 18.719L11.9815 24.0001V13.5246C12.0032 13.5137 12.0248 13.5022 12.0461 13.4898L21.5667 7.99311Z",
    fill: "#FEC53D",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499209,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.291382 5.53649C0.404661 5.39344 0.54764 5.27254 0.714336 5.18376L10.1498 0.158228C10.5459 -0.0527426 11.021 -0.0527426 11.4171 0.158228L20.8526 5.18376C20.9811 5.2522 21.0955 5.33972 21.193 5.44177L10.8481 11.4144C10.7801 11.4537 10.7173 11.4986 10.6602 11.5483C10.603 11.4986 10.5403 11.4537 10.4723 11.4144L0.291382 5.53649Z",
    fill: "#FEC53D",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg5);
export default __webpack_public_path__ + "static/media/svg5.0fecd6142e44286bbfd42083a3d486c4.svg";
export { ForwardRef as ReactComponent };